import ApiServices from "@/services/uteis/ApiServices.js";
import endpoint from "@/libs/endPoint/administrativo/AdminConfig.endpoint";

class AdminConfigServices {
  // Não precisa de construtor
  async validarVersao() {
    const { data } = await ApiServices.get(endpoint.version);
    return data;
  }
}

export default new AdminConfigServices();
